export enum PaymentStatusEnum {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4,
  Closed = 5,
  TranscriptionRequired = 6,
  TreasurerApprovalRequired = 7,
  FinalApprovalRequired = 8,
  SalesOfficerApprovalRequired = 9,
}
export enum PaymentModeTypeEnum {
  Automatic = 1,
  Manual = 2,
}
